import React, { useMemo } from 'react';
import './loader.scss';

const Loader = () => useMemo(() => (
  <div className="loader-back">
    <div className="loader"/>
  </div>
), []);

export default Loader;